"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustmentDayOffTypes = void 0;
exports.adjustmentDayOffTypes = {
    SET_LOADING: 'ADJUSTMENT DAY OFF TYPES SET LOADING',
    SET_ERROR: 'ADJUSTMENT DAY OFF TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'ADJUSTMENT DAY OFF TYPES GET DATA GRID',
    ON_SYNC_DATA: 'ADJUSTMENT DAY OFF TYPES SET SYNC LOADING',
    ON_PAGE_CHANGE: 'ADJUSTMENT DAY OFF TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE: 'ADJUSTMENT DAY OFF TYPES ON SORT CHANGE',
    ON_MUTATION_CLICK: 'ADJUSTMENT DAY OFF TYPES ON MUTATION',
    ON_FILTER_CHANGE: 'ADJUSTMENT DAY OFF TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'ADJUSTMENT DAY OFF TYPES ON SAVE DATAITEM',
    SET_DATA_CALENDAR: 'ADJUSTMENT DAY OFF TYPES GET DATA CALENDAR',
    SYNC_DATA_CALENDAR: 'ADJUSTMENT DAY OFF TYPES SYNC DATA CALENDAR',
    ON_CHANGE_DATAITEM: 'ADJUSTMENT DAY OFF TYPES ON CHANGE DATAITEM',
    ON_DELETE_DATAITEM: 'ADJUSTMENT DAY OFF TYPES ON DELETE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'ADJUSTMENT DAY OFF TYPES SET SUCCESS MODAL',
};
